import ActivityCard from "components/ActivityPanel/ActivityCard";
import moment from "moment";
import React from "react";
import ESignActivityCardContent from "./ESignActivityCardContent";

const displayRemoteAddressActions: server.dto.ESignActions[] = [
  "openDownloadOtherFile",
  "accessedInvitation",
  "senderPlaceSignature",
  "signerPlaceSignature",
  "linkToUser"
];

interface Props {
  activity: server.dto.ESignActivity
}

const ESignActivityCard = (props: Props) => {
  const { activity } = props;
  const { lifeCycle, version, timestampUtc, action } = activity;

  const timstampUtcMoment = moment.utc(timestampUtc);

  let cardColor;
  switch (lifeCycle) {
    case "draft":
      cardColor = "gray-dark";
      break;
    case "review":
      cardColor = "purple";
      break;
    case "pending":
      cardColor = "orange";
      break;
    case "completed":
      cardColor = "green";
      break;
    case "discarded":
      cardColor = "gray";
      break;
    default:
      cardColor = "";
      break;
  };

  const subtitles = [`${RESX.ESign.Version} ${version}`, `${timstampUtcMoment.fromNow()}`];
  if (displayRemoteAddressActions.includes(action.value)) {
    subtitles.push(`${activity.remoteAddress}`);
  }

  const title = activity.action.text.replace("{version}", version.toString());

  return <ActivityCard
    activity={activity}
    cardColor={cardColor}
    overrideTitle={() => title}
    overrideSubtitle={() => subtitles}
  >
    <ESignActivityCardContent activity={activity} />
  </ActivityCard>;
};

export default ESignActivityCard;